exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".offboarding-event-details { margin: 8px 0 0 16px; padding-left: 12px; border-left: 2px solid #dce2e6; font-size: 13px; line-height: 1.5; overflow-wrap: break-word; }\r\n.offboarding-event-details > div + div { margin-top: 8px; }\r\n.offboarding-event-details strong { font-weight: 600; }\r\n.offboarding-event-details p { margin: 4px 0 0; }\r\n.offboarding-event-details .offboarding-history-proposal { padding: 8px; }\r\n@media (max-width: 640px) {\r\n  .offboarding-event-details { margin-left: 8px; padding-left: 8px; }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-history-event.component.css
// module id = ../../../../../src/app/content-page/offboarding/offboarding-history-event.component.css
// module chunks = main